module.exports = __webpack_public_path__ + "img/adaptations4.db635cc9.png";